import { getUrlParam } from "./utils.mjs";
const THEME = {
  LIGHT: "white",
  DARK: "black"
};
function getLanguage() {
  const isWxMiniProgram = typeof wx !== "undefined" && wx.getSystemInfoSync;
  let language = getUrlParam("lang") || navigator.language || (isWxMiniProgram ? "zh-CN" : "en-US");
  language = language.replace(/_/, "-").toLowerCase();
  const isZh = language.startsWith("zh");
  language = isZh ? "zh-CN" : "en-US";
  return language;
}
function toTargetTheme(themeOption) {
  const theme = themeOption === "DARK" ? THEME.DARK : THEME.LIGHT;
  return theme;
}
const invalidDigitalPasswordRegex = /[^\d]+/g;
const invalidPasswordRegex = /[^A-Za-z0-9!@#$%^&*()_+{}|:"<>?`~';[\]\\/.,-=]+/g;
export {
  getLanguage,
  invalidDigitalPasswordRegex,
  invalidPasswordRegex,
  toTargetTheme
};
